import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import user from "./modules/user";
import getters from "./getters";
import common from './modules/common'

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    workCode: "CJ01",
    qsId:"",
    workId:"",
    type:"SL",
    params:'',
    pondType: "1",
    dataChart: [],
    dataChart1: [],
    lockScreen:false,
    todo:false,
    lockAudio:false,
    message:{},
    wljTitle:'',
  },
  mutations: {
    changeDeviceType(state, value) {
      state.type = value;
    },
    changePondType(state, value) {
      state.pondType = value;
    },
    changeType(state, value) {
      state.workCode = value;
    },
    changeWljName(state, value) {
      state.wljTitle = value;
    },
    changeWorkId(state, value) {
      state.workId = value;
    },
    changeQsId(state, value) {
      state.qsId = value;
    },
    setParams(state,value){
      state.params = value
    },
    CHANGE_DATA(state, value) {
      state.dataChart = value;
    },
    CHANGE_DATA1(state, value) {
      state.dataChart1 = value;
    },
    changeLock(state, value) {
      state.lockScreen = value;
    },
    changeMessage(state, value) {
      state.message = value;
    },
    changeAudioLock(state, value) {
      state.lockAudio = value;
    },
    changeTodo(state, value){
      state.todo=value
    }
  },
  modules: {
    user,
    common,
  },
  getters,
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      reducer(val) {
        return {
          // 只存储state中的userData
          workCode: val.workCode,
          workId:val.workId
        };
      },
    }),
    createPersistedState({
      storage: window.localStorage,
      reducer(val) {
        return {
          // 只存储state中的userData
          workCode: val.workCode,
          workId:val.workId,
          qsId:val.qsId,
          params:val.params
        };
      },
    }),
  ],
});

export default store;
